module.exports = "<div class=container style=margin-top:5%> <div class=\"jumbotron text-center\"> <h1>Loading..</h1> Returning back to application </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/app/authorization/authorized/index.html
// module id = 380
// module chunks = 0